import { connect } from 'react-redux';
import { Billing as BillingComponent } from './billing.component';

export const Billing = connect(sState => ({ sState }))(BillingComponent);